import axios from 'axios'

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"

const apiClient = axios.create({
  baseURL: process.env.BACKEND_HOST
})

const url_list = {
  url_discount: 'api/v1/ipanel/discounts/',
}

export default {
    getDiscountList(perPage, page, searchQuery) {
      var relativeURL = url_list.url_discount + '?page_size=' + perPage + '&page=' + page

      if (searchQuery) {
        relativeURL += '&search=' + searchQuery
      }
      return apiClient.get(relativeURL)
    },
    createDiscount(data) {
      return apiClient.post(url_list.url_discount, data)
    },
    getDiscountDetail(discount_id) {
      return apiClient.get(url_list.url_discount + discount_id + '/')
    },
    updateDiscount(form_data) {
      return apiClient.patch(url_list.url_discount + form_data.discount_id + '/', form_data.data)
    },
    getAdditionalCostList() {
      return apiClient.get(url_list.url_discount + 'get-additional-cost-list/')
    }
}